import { useMutation, type UseMutationResult } from '@tanstack/react-query';
import { userApi } from '../userApi';
import { MutationKey } from '@shared/config';
import {
  type ChangeActivityRequest,
  type ChangeActivityResponse,
} from '../types';
import type { AxiosError } from 'axios';
import type { TFormErrorResponse } from '@shared/types';

export const useChangeActivity = (
  id: string
): UseMutationResult<
  ChangeActivityResponse,
  AxiosError<TFormErrorResponse>,
  ChangeActivityRequest
> => {
  return useMutation({
    mutationKey: [MutationKey.UPDATE_USER_ACTIVITY],
    mutationFn: (data: ChangeActivityRequest) =>
      userApi.changeActivity(id, data),
  });
};
